<template>
  <div>
    <OrderBar
      :order="order"
      :loaded="orderLoaded"
      :deprecated-order="isDeprecatedOrder"
      :deprecated-order-loaded="deprecatedOrderLoaded"
    />

    <!-- Order Has Been Loaded -->
    <div v-if="orderLoaded" class="grid grid-cols-5 gap-2 text-sm m-3">
      <!-- Left Column -->
      <div class="flex flex-col col-span-1 space-y-4">
        <OrderCustomerInfo :order="order" />
        <RelatedOrder v-if="hasRelatedOrders" :order="order" />
      </div>

      <!-- Right Column -->
      <div class="flex flex-col col-span-4 space-y-4">
        <div
          class="flex flex-none flex-col bg-white overflow-hidden shadow rounded-lg justify-left"
        >
          <tabs>
            <!-- Notes Tab -->
            <tab title="Notes">
              <OrderNotes
                :notes="order.notes"
                :order-number="order.SourceOrderNumber"
                :status="order.status"
              />
            </tab>
            <!-- Misc Tab -->
            <tab title="Misc">
              <OrderMisc :order="order" />
            </tab>
          </tabs>
        </div>
        <!-- No overflow-hidden: the Products / Tracking / Totals Actions menus drop below short tables -->
        <div
          class="flex flex-none flex-col bg-white shadow rounded-lg justify-left"
        >
          <OrderDetails
            :order="order"
          />
        </div>
      </div>
    </div>

    <!-- No Order loaded -->
    <div v-else>
      <div v-if="orderSearching" class="flex items-center space-x-2">
        <span>Searching</span>
        <LoadingSpinner class="text-gray-400" />
      </div>
      <div class="font-bold" v-else-if="isDeprecatedOrder">
        Order can no longer be edited
      </div>
      <div v-else>No Order Loaded</div>
    </div>
  </div>
</template>
<script>
import OrderCustomerInfo from "./components/OrderCustomerInfo.vue";
import OrderNotes from "./components/OrderNotes.vue";
import OrderMisc from "./components/OrderMisc.vue";
import OrderDetails from "./components/OrderDetails.vue";
import OrderBar from "./components/OrderBar.vue";
import Tabs from "@/components/elements/Tabs.vue";
import Tab from "@/components/elements/Tab.vue";
import RelatedOrder from "@/views/Customers/components/RelatedOrder";

export default {
  name: "Orders",
  props: {
    orderNumber: {
      type: [String, Number],
      required: false,
      default: undefined
    }
  },
  data() {
    return {
      slideoverVisibleSearch: false,
    };
  },
  watch: {
    $route(to) {
      if (this.orderHasBeenLoaded()) {
        return false;
      }

      this.$store.dispatch("orders/fetchOrder", to.params.orderNumber);
    }
  },
  async created() {
    if (this.orderHasBeenLoaded()) {
      return false;
    }

    if (this.orderNumber == undefined) {
      return false;
    }

    this.$store.dispatch("orders/fetchOrder", this.orderNumber);
  },
  mounted() {},
  components: {
    RelatedOrder,
    OrderCustomerInfo,
    OrderNotes,
    OrderMisc,
    OrderDetails,
    OrderBar,
    Tabs,
    Tab
  },
  computed: {
    isDeprecatedOrder() {
      return this.deprecatedOrderLoaded;
    },
    deprecatedOrder() {
      return this.$store.getters["orders/get"]("deprecatedOrder");
    },
    deprecatedOrderLoaded() {
      return this.$store.getters["orders/get"]("deprecatedOrderLoaded");
    },
    order() {
      if (this.isDeprecatedOrder) {
        return this.deprecatedOrder;
      }
      return this.$store.getters["orders/get"]("order");
    },
    orderLoaded() {
      return this.$store.getters["orders/get"]("orderLoaded");
    },
    orderSearching() {
      return this.$store.getters["orders/get"]("orderSearching");
    },
    hasRelatedOrders() {
      return this.order?.relations?.length;
    }
  },
  methods: {
    toggleSlideover() {
      this.slideoverVisibleSearch = !this.slideoverVisibleSearch;
    },
    orderHasBeenLoaded() {
      return this.$route.params.orderNumber == this.order.SourceOrderNumber;
    }
  },
  filters: {}
};
</script>
